/*
	DO NOT MODIFY MANUALLY
	Generated by: generateModel.ts
*/

export class GetIdNowUserInput {
	idNowTransactionId: string = ''
}